import CustomComponent from 'CustomModules/SelfService/components/CustomComponent/CustomComponent'
import BotonSolicitarVacaciones from 'CustomModules/SelfService/pages/Dashboard/BotonSolicitarVacaciones'
import BotonSolicitarPermisos from 'CustomModules/SelfService/pages/Dashboard/BotonSolicitarPermisos'
import ModalActualizarDatos from 'CustomModules/SelfService/pages/Dashboard/ModalActualizarDatos'
import MyPayroll from 'CustomModules/SelfService/pages/Dashboard/MyPayroll'
import HistoricoSolicitudesAprobadas from 'CustomModules/SelfService/pages/Dashboard/HistoricoSolicitudesAprobadas'
import ModalMyTeam from 'CustomModules/SelfService/pages/Dashboard/ModalMyTeam'
import BotonSolicitarRecuperacion from 'CustomModules/SelfService/pages/Dashboard/BotonSolicitarRecuperacion'
import ModalMyVacation from './pages/Dashboard/ModalMyVacation'
import ModalNovMyTeam from './pages/Dashboard/ModalNovMyTeam'
import BotonMisActividadesGeo from './pages/Dashboard/BotonMisActividadesGeo'
import BotonSolicitarCesantias from './pages/Dashboard/BotonSolicitarCesantias'

export const Components = [
  {name: 'custom-component', component: CustomComponent},
  {name: 'btn-solicitar-vacaciones', component: BotonSolicitarVacaciones},
  {name: 'btn-solicitar-permisos', component: BotonSolicitarPermisos},
  {name: 'modal-actualizar-datos', component: ModalActualizarDatos},
  {name: 'modal-my-payroll', component: MyPayroll},
  {name: 'modal-historico-solicitudes', component: HistoricoSolicitudesAprobadas},
  {name: 'modal-my-team', component: ModalMyTeam},
  {name: 'btn-solicitar-recuperacion', component: BotonSolicitarRecuperacion},
  {name: 'modal-my-vaca', component: ModalMyVacation},
  {name: 'modal-nov-my-team', component: ModalNovMyTeam},
  {name: 'btn-mis-actividades-geo', component: BotonMisActividadesGeo},
  {name: 'btn-solicitar-cesantias', component: BotonSolicitarCesantias}
]



// WEBPACK FOOTER //
// ./src/customization/SelfService/components.js